module.exports = __webpack_public_path__ + "assets/img/stars_sm.ac6bfb86.webp";